/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class CanvasDnDAPI
 * @hideconstructor
 * @classdesc  API class that handles drag and drop on a canvas
 */
define([], () => {
	return class CanvasDnDAPI {

		/**
		 * @function CanvasDnDAPI#registerProvider
		 * @description Register a provider to handle drag and drop
		 * @param {provider} provider provider to handle drag and drop
		 */
		registerProvider() { }

		/**
		 * @public
		 * @function CanvasDnDAPI#accepts
		 * @param {Object} payload the drag and drop payload
		 * @description called by the DnD manager to check whether to accept the dragged object or not
		 * @returns {Boolean}
		 */
		accepts() {}

		/**
		 * @public
		 * @function CanvasDnDAPI#onDrop
		 * @param {Object} payload the drag and drop payload
		 * @param {Object} targetNode the DOM target node to accept the drop
		 * @param {Object} event the jQuery event object
		 * @description process the on drop action of drag and drop
		 */
		onDrop () {}
	};
});
